import { render, staticRenderFns } from "./VInventoryItemRepairReturnModal.vue?vue&type=template&id=02a9fad0"
import script from "./VInventoryItemRepairReturnModal.vue?vue&type=script&lang=js"
export * from "./VInventoryItemRepairReturnModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports